export default __webpack_public_path__ + "static/media/Graphwallet.1db4972f.svg";